import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsWorkflowsAssociateRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-workflows-associate',
	path: '/secure/project/SelectProjectWorkflowScheme!default.jspa',
};
